var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 0C3.86875 0 3.25 0.61875 3.25 1.375V20.625C3.25 21.3813 3.86875 22 4.625 22H18.375C19.1313 22 19.75 21.3813 19.75 20.625V5.5L14.25 0H4.625Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5.5H19.75L14.25 0V4.125C14.25 4.88125 14.8687 5.5 15.625 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 9.625L15.625 5.5H19.75V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.875C17 18.2531 16.6906 18.5625 16.3125 18.5625H1.1875C0.809375 18.5625 0.5 18.2531 0.5 17.875V11C0.5 10.6219 0.809375 10.3125 1.1875 10.3125H16.3125C16.6906 10.3125 17 10.6219 17 11V17.875Z",
    fill: "#CB1801"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65625 13.026C3.65625 12.8445 3.79925 12.6465 4.02956 12.6465H5.29937C6.01437 12.6465 6.65787 13.125 6.65787 14.0421C6.65787 14.9111 6.01437 15.3951 5.29937 15.3951H4.38156V16.1211C4.38156 16.3631 4.22825 16.4999 4.03025 16.4999C3.84875 16.4999 3.65694 16.3631 3.65694 16.1211V13.026H3.65625ZM4.38156 13.3388V14.7083H5.29937C5.66787 14.7083 5.95937 14.3831 5.95937 14.0421C5.95937 13.6578 5.66787 13.3388 5.29937 13.3388H4.38156Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35938 13.026C7.35938 12.8445 7.50238 12.6465 7.73338 12.6465H9.00319C9.71819 12.6465 10.3617 13.125 10.3617 14.0421C10.3617 14.9111 9.71819 15.3951 9.00319 15.3951H8.08537V16.1211C8.08537 16.3631 7.93138 16.4999 7.73338 16.4999C7.55188 16.4999 7.35938 16.3631 7.35938 16.1211V13.026ZM8.08469 13.3388V14.7083H9.0025C9.371 14.7083 9.6625 14.3831 9.6625 14.0421C9.6625 13.6578 9.371 13.3388 9.0025 13.3388H8.08469Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0895 13.3835H11.1284C10.6499 13.3835 10.6499 12.6802 11.1284 12.6802H13.7278C14.2173 12.6802 14.2173 13.3835 13.7278 13.3835H12.8155V16.1596C12.8155 16.6374 12.0895 16.6491 12.0895 16.1596V13.3835Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 18.5625H3.25V19.25H16.3125C16.6906 19.25 17 18.9406 17 18.5625V17.875C17 18.2531 16.6906 18.5625 16.3125 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.e1fd9cd33bc2a2001e69e443a8572495.svg";
export { ForwardRef as ReactComponent };